/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetId } from "../../commons/types/SheetId";
export const WorkbookConfigSettings = core.serialization.object({
    trackChanges: core.serialization.boolean().optional(),
    noMappingRedirect: core.serialization.boolean().optional(),
    sheetSidebarOrder: core.serialization.list(SheetId).optional(),
    autoRunAnalysis: core.serialization.boolean().optional(),
});
